import React, { useMemo, memo } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  FormControlLabel,
  Checkbox,
  ToggleButtonGroup,
  ToggleButton,
  Badge,
} from "../../../../components";
import { LIVE_TYPE, MACHINE_TYPE } from "../constants";

const useStyles = makeStyles({
  toggleButton: {
    flex: 1,
  },
  buttonGroup: {
    width: "100%",
  },
  badge: {
    position: "absolute",
    top: 0,
    right: 0,
  },
});

const hasSimilarErrorTypes = (errors, startWith, mustContain) =>
  Object.keys(errors).some(
    (key) => key.startsWith(startWith) && key.includes(mustContain)
  );

function VoiceTypeToggle({
  onToggleAnsweringMachine,
  onTabChange,
  activeTab,
  errors,
  copyLiveToAnseringMachine,
  onToggleCopyLiveToAnsweringMachine,
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const hasLiveErrors = useMemo(
    () => hasSimilarErrorTypes(errors, "voiceTemplate", LIVE_TYPE),
    [errors]
  );
  const hasMachineErrors = useMemo(
    () => hasSimilarErrorTypes(errors, "voiceTemplate", MACHINE_TYPE),
    [errors]
  );

  const copyLive = Boolean(copyLiveToAnseringMachine);
  const handleChange = (_, tab) => {
    if (tab !== null) {
      onToggleAnsweringMachine();
      // clicking on the already active tab, tab = null
      onTabChange(null, tab);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={6} md={6} sm={6}>
        <ToggleButtonGroup
          data-test-id="master-template-voice-active-tab-toggle"
          size="small"
          color="primary"
          onChange={handleChange}
          value={activeTab}
          exclusive
          fullWidth
          className={classes.buttonGroup}
        >
          <ToggleButton
            color="primary"
            value={LIVE_TYPE}
            className={classes.toggleButton}
          >
            {hasLiveErrors && (
              <Badge badgeContent="!" color="error" className={classes.badge} />
            )}
            {t("Live")}
          </ToggleButton>
          <ToggleButton value={MACHINE_TYPE} className={classes.toggleButton}>
            {hasMachineErrors && (
              <Badge badgeContent="!" color="error" className={classes.badge} />
            )}
            {t("Answering Machine")}
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>

      {activeTab === MACHINE_TYPE && (
        <Grid item xs={6} md={6} sm={6}>
          <FormControlLabel
            control={
              <Checkbox
                data-test-id="master-template-voice-copy-live-to-answering-machine"
                checked={copyLive}
                onChange={onToggleCopyLiveToAnsweringMachine}
                color="primary"
              />
            }
            label={t(
              "Use the same message for answering machines as for the live calls."
            )}
          />
        </Grid>
      )}
    </Grid>
  );
}

export default memo(VoiceTypeToggle);
